import { render } from "./ChartIcon.vue?vue&type=template&id=c5f7a7d2"
const script = {}
script.render = render

export default script